import { IActionContext } from '@msdyn365-commerce/core-internal';
/**
 * Get Unit Translation from item unit
 * @param string
 * @constructor
 */
// props.context.request.locale
export const GetUnitTranslation = (context: IActionContext, DefaultUnitOfMeasure?: string): string => {
    if (DefaultUnitOfMeasure === undefined) {
        return '';
    }

    try {
        if (DefaultUnitOfMeasure === 'pi2_sf') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'pi²';
                case 'en-US':
                    return 'sq.ft';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'rgs_pn') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'rgs';
                case 'en-US':
                    return 'pn';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'pqt_bdl') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'pqt';
                case 'en-US':
                    return 'bdl';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'po2_si') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'po²';
                case 'en-US':
                    return 'si';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'po_in') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'po';
                case 'en-US':
                    return 'in';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'pmp_bf') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'pmp';
                case 'en-US':
                    return 'bf';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'pi3_cf') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'pi3';
                case 'en-US':
                    return 'cf';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'pi_ft') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'pi';
                case 'en-US':
                    return 'ft';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'bte_box') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'bte';
                case 'en-US':
                    return 'box';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'board_lis') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'lisière';
                case 'en-US':
                    return 'board';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else if (DefaultUnitOfMeasure === 'board_lis') {
            switch (context.requestContext.locale) {
                case 'fr-CA':
                    return 'au 1000';
                case 'en-US':
                    return 'per 1000';
                default:
                    return DefaultUnitOfMeasure;
            }
        } else {
            return DefaultUnitOfMeasure;
        }
    } catch (error) {
        // Return the original input value if any error occurs
        console.error(`Error processing unit translation: ${(error as Error).message}`);
        return DefaultUnitOfMeasure;
    }
};
